/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Document, Font, Image, Link, Page, StyleSheet,
  Text, View,
} from '@react-pdf/renderer';
import React from 'react';

import { formatPhoneDotsIntl, formatPhoneNumber, httpsRegex } from 'utils/lib';
import { montserratFont, vidalokaFont } from 'utils/pdf-fonts';

Font.register(vidalokaFont);

Font.register(montserratFont);

const styles = StyleSheet.create({
  page: {
    position: 'relative',
  },
  background: {
    position: 'absolute',
    top: -1, // -1 on all of these to fix off-by-1 errors with the background images
    left: -1,
    right: -1,
    bottom: -1,
  },
  footerContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
  },
  agentPicture: {
    position: 'absolute',
    top: 0,
    left: '1.13in',
    width: '0.9in',
    height: '1.15in',
    objectFit: 'cover',
    borderRadius: '12px',
  },
  teamOrCompanyLogo: {
    position: 'absolute',
    top: 0,
    left: '6.25in',
    width: '1.22in',
    height: '0.8in',
    objectFit: 'contain',
    objectPosition: 'center bottom',
  },
  agentInfoText: {
    color: '#f1f0ea',
    position: 'absolute',
    top: '-0.02in',
    left: '2.25in',
  },
  link: {
    color: '#f1f0ea',
    textDecoration: 'none',
  },
});

const Footer = ({ userInfo, footerTop, logoTopMargin }: any) => (
  <View style={{ ...styles.footerContainer, top: footerTop }}>
    <Image src={userInfo.agentInfo.agentPictureUrl} style={styles.agentPicture} />

    <View style={styles.agentInfoText}>
      <Text style={{
        fontFamily: 'Vidaloka',
        fontSize: '18px',
        textTransform: 'uppercase',
        marginBottom: '4px',
      }}
      >
        {`${userInfo.firstName} ${userInfo.lastName ?? ''}`}
      </Text>

      <Text style={{
        fontFamily: 'Montserrat',
        fontWeight: 700,
        fontSize: '8px',
        textTransform: 'uppercase',
      }}
      >
        {`Lic. # ${userInfo.agentInfo.agentDreNumber}`}
      </Text>

      <Text style={{
        fontFamily: 'Montserrat',
        fontWeight: 600,
        fontSize: '14px',
        margin: '5px 0',
        letterSpacing: '1.2px',
      }}
      >
        <Link src={`tel:${formatPhoneNumber(userInfo.agentInfo.marketingPhoneNumber, true)}`} style={styles.link}>
          {formatPhoneDotsIntl(userInfo.agentInfo.marketingPhoneNumber)}
        </Link>
      </Text>

      <Text style={{
        fontFamily: 'Montserrat',
        fontWeight: 400,
        fontSize: '9px',
      }}
      >
        <Link src={`mailto:${userInfo.agentInfo.marketingEmail}`} style={styles.link}>
          {userInfo.agentInfo.marketingEmail}
        </Link>
      </Text>

      {userInfo.agentInfo.website && (
        <Text style={{
          fontFamily: 'Montserrat',
          fontWeight: 400,
          fontSize: '9px',
        }}
        >
          <Link src={userInfo.agentInfo.website} style={styles.link}>
            {userInfo.agentInfo.website.replace(httpsRegex, '')}
          </Link>
        </Text>
      )}
    </View>

    <Image
      src={userInfo.agentInfo.teamLogoLightUrl
        ?? userInfo.agentInfo.teamLogoUrl
        ?? userInfo.agentInfo.companyLogoLightUrl
        ?? userInfo.agentInfo.companyLogoUrl}
      style={{
        ...styles.teamOrCompanyLogo,
        marginTop: logoTopMargin,
      }}
    />
  </View>
);

const SevenMistakesDocument = ({ name, userInfo }: any) => (
  <Document title={name} author="Harvist">
    <Page size={{ width: '8.5in', height: '11in' }} style={styles.page}>
      <Image src="/free-resources/seven-mistakes-home-sellers-make/1.png" style={styles.background} />
      <Footer userInfo={userInfo} footerTop="9.12in" logoTopMargin="0.05in" />
    </Page>

    <Page size={{ width: '8.5in', height: '11in' }} style={styles.page}>
      <Image src="/free-resources/seven-mistakes-home-sellers-make/2.png" style={styles.background} />
      <Footer userInfo={userInfo} footerTop="9.6in" logoTopMargin="-0.04in" />
    </Page>

    <Page size={{ width: '8.5in', height: '11in' }} style={styles.page}>
      <Image src="/free-resources/seven-mistakes-home-sellers-make/3.png" style={styles.background} />
      <Footer userInfo={userInfo} footerTop="9.6in" logoTopMargin="-0.04in" />
    </Page>
  </Document>
);

export default SevenMistakesDocument;
